import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec6a156"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-8 min-h-90vh font-heebo" }
const _hoisted_4 = { class: "question-label question-label-project2" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "green-arrow" }, "←", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "justify-center w-full mt-4 grid grid-cols-3 sm:grid-cols-5" }
const _hoisted_11 = ["onDragstart", "onDrop"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "text-sm text-project2-dark mt-2 font-normal text-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "text-sm text-project2-dark mt-2 font-normal text-center" }
const _hoisted_16 = { class: "bg-white p-4 flex flex-col min-w-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.config.title), 1)
            ]),
            _createElementVNode("p", {
              class: "mt-8 w-full sm:max-w-half",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_5),
            (!_ctx.done)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.config.image1,
                    alt: "Shirt",
                    class: "w-36",
                    draggable: "true",
                    "data-source": "true"
                  }, null, 8, _hoisted_7),
                  _hoisted_8,
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["drop flex flex-col w-100 p-1 mt-4 justify-self-center", {'selected': key == _ctx.state.answers.value?.[_ctx.config.answerKey]}]),
                  key: key,
                  onDragstart: ($event: any) => (_ctx.startDrag($event, key)),
                  onDragover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dragEnter($event))),
                  onDragleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragLeave($event))),
                  onDragenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dragEnter($event))),
                  onDrop: ($event: any) => (_ctx.handleDrop($event, key, _ctx.$t(option)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.config.optionsImages[key],
                    alt: `target image ${key}`
                  }, null, 8, _hoisted_12),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t(option)), 1)
                ], 42, _hoisted_11))
              }), 128)),
              (_ctx.config.optionsOther.enabled)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "drop flex flex-col w-100 p-1 mt-4 justify-self-center",
                    onDragover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragEnter($event))),
                    onDragleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragLeave($event))),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.otherModalShow = true;}),
                    onDragenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dragEnter($event))),
                    onDrop: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleDrop($event, _ctx.config.optionsOther.key)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.config.optionsImages[_ctx.config.optionsOther.key],
                      alt: "Other solutions"
                    }, null, 8, _hoisted_14),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(_ctx.config.optionsOther.value)), 1)
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              "button-class": "action-button action-button-project2 mt-8"
            }, null, 8, ["go-to", "next-screen"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.otherModalShow,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.otherModalShow) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_ctx.config.optionsOther.value)), 1),
          _withDirectives(_createElementVNode("textarea", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.otherReason) = $event)),
            class: "w-full border-2 border-gray-300 p-2 rounded-lg"
          }, "\n                  ", 512), [
            [_vModelText, _ctx.otherReason]
          ]),
          _createVNode(_component_ActionButton, {
            text: "buttons.submit",
            onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.answer(_ctx.otherReason, {}); _ctx.next();}),
            "color-class": "action-button-project2",
            class: "right mt-4"
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}